export default __webpack_public_path__ + "static/media/to-top.0da52608.png";